import * as go from 'gojs';

export const getTopCenterObjectPoint = (graphObject?: go.Part | null) => {
  if (!graphObject) {
    return { x: 0, y: 0 };
  }

  const diagram = graphObject.diagram;
  if (!diagram) {
    return { x: 0, y: 0 };
  }
  const { leftOffset, topOffset } = getDiagramOffset(diagram);
  const { x, y, width } = diagram.computePartsBounds([graphObject]);
  const { x: documentPointX, y: documentPointY } = diagram.transformDocToView(new go.Point(x + width / 2, y));

  return {
    x: documentPointX + leftOffset,
    y: documentPointY + topOffset,
  };
};

export const getTopLeftObjectPoint = (graphObject: go.GraphObject) => {
  const { leftOffset, topOffset } = getDiagramOffset(graphObject.diagram);
  const { x, y } = graphObject.getDocumentPoint(go.Spot.TopLeft);
  const { x: documentPointX, y: documentPointY } = graphObject.diagram?.transformDocToView(new go.Point(x, y)) || {
    x: 0,
    y: 0,
  };

  return {
    x: documentPointX + leftOffset,
    y: documentPointY + topOffset,
  };
};

const getDiagramOffset = (diagram: go.Diagram | null) => {
  const { top, left } = diagram?.div?.getBoundingClientRect() || { top: 0, left: 0 };

  return {
    leftOffset: left,
    topOffset: top,
  };
};
